module.exports = __webpack_public_path__ + "fonts/line-awesome.8b12905.woff";